import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { UserService } from '@core/auth/services/user.service';
import { STORAGE_KEYS, LEGACY_STORAGE_KEYS } from '@shared/constants';

@Component({
  selector: 'app-user-profile-modal',
  templateUrl: './user-profile-modal.component.html',
  styleUrls: ['./user-profile-modal.component.scss']
})
export class UserProfileModalComponent implements OnInit, OnChanges {
  @Input() isOpen = false;
  @Output() fechado = new EventEmitter<void>();
  @Output() openConta = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  usuario = {
    nome: '',
    username: '',
    avatar: null as string | null
  };

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.loadUserInfo();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && changes['isOpen'].currentValue) {
      // Aguardar um pouco para garantir que o AngularJS está disponível
      setTimeout(() => {
        this.loadUserInfo();
      }, 100);
    }
  }

  private loadUserInfo() {
    try {
      // Prioridade 1: API /user-accounts/v0.1/api/users/@me (usuário logado, fonte mais confiável)
      const userFromApi = this.userService.userInfo;
      if (userFromApi) {
        this.usuario.nome = userFromApi.name || '';
        this.usuario.username = userFromApi.id || '';
        if (this.usuario.nome) return;
      }

      // Prioridade 2: AngularJS AuthenticationContext (modo híbrido com AngularJS ativo)
      try {
        const angular = (window as { angular?: { element: (el: Element) => { injector: () => { get: (name: string) => unknown } | null } } }).angular;
        if (angular) {
          const injector = this.getAngularJSInjector();
          if (injector) {
            const authContext = injector.get('AuthenticationContext') as { getUserInfo?: () => { nome?: string; name?: string; username?: string; user?: string } } | null;
            if (authContext?.getUserInfo) {
              const userInfo = authContext.getUserInfo();
              if (userInfo) {
                this.usuario.nome = userInfo.nome || userInfo.name || this.usuario.nome;
                this.usuario.username = userInfo.username || userInfo.user || this.usuario.username;
              }
            }

            if (!this.usuario.username) {
              try {
                const applicationContext = injector.get('ApplicationContext') as { getUserAccess?: () => { user?: string } } | null;
                if (applicationContext?.getUserAccess) {
                  const userAccess = applicationContext.getUserAccess();
                  if (userAccess?.user) {
                    this.usuario.username = userAccess.user;
                  }
                }
              } catch (e) {
                // ignora
              }
            }

            if (this.usuario.nome && this.usuario.username) return;
          }
        }
      } catch (error) {
        // segue para as próximas fontes
      }

      // Prioridade 3: userInfo salvo pelo MobileContextService (contexto completo)
      // Fallback de leitura na chave antiga (__pwa_bridge_contexto_completo) por 1 release — TODO remover
      const contextoCompleto = localStorage.getItem(STORAGE_KEYS.BRIDGE_CONTEXTO_COMPLETO) ||
        localStorage.getItem(LEGACY_STORAGE_KEYS.BRIDGE_CONTEXTO_COMPLETO);
      if (contextoCompleto) {
        const contexto = JSON.parse(contextoCompleto);
        if (contexto.userInfo) {
          const userInfo = contexto.userInfo;
          this.usuario.nome = userInfo.nome || userInfo.name || this.usuario.nome;
          this.usuario.username = userInfo.user || userInfo.username || this.usuario.username;
        }
      }

      if (!this.usuario.nome) {
        this.usuario.nome = 'Usuário';
      }
      if (!this.usuario.username) {
        this.usuario.username = '';
      }
    } catch (error) {
      this.usuario.nome = 'Usuário';
      this.usuario.username = '';
    }
  }

  private getAngularJSInjector(): { get: (name: string) => unknown } | null {
    try {
      const angular = (window as { angular?: { element: (el: Element) => { injector: () => { get: (name: string) => unknown } | null } } }).angular;
      if (!angular) {
        return null;
      }

      const elements: (Element | Document | null)[] = [
        document.body,
        document,
        document.documentElement
      ];

      for (const element of elements) {
        if (element) {
          try {
            // AngularJS aceita Element ou Document, mas TypeScript precisa de cast
            const injector = (angular.element as (el: Element | Document) => { injector: () => { get: (name: string) => unknown } | null })(element).injector();
            if (injector) {
              return injector;
            }
          } catch (e) {
            // tenta o próximo elemento
          }
        }
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  onClose() {
    this.fechado.emit();
  }

  onConta() {
    this.openConta.emit();
  }

  onLogout() {
    this.logout.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.onClose();
    }
  }
}

